import { useCallback } from 'react';
import { useConnect, useDisconnect } from 'wagmi';

import { WEB3_AUTH_METHOD_CACHE_KEY } from 'shared/consts';
import { useTypedDispatch } from 'store';
import { dropAlertState, setAlertState } from 'store/slices/ui';

interface IUseMetamaskAuthReturn {
  connect: () => Promise<void>;
  disconnect: () => void;
}

const useMetamaskAuth = (): IUseMetamaskAuthReturn => {
  const { connectAsync, connectors } = useConnect();
  const { disconnect: deactivate } = useDisconnect();

  const dispatch = useTypedDispatch();

  const connect = useCallback(async () => {
    localStorage.setItem(WEB3_AUTH_METHOD_CACHE_KEY, 'metamask');

    try {
      const connector = connectors.find(el => el.type === 'injected');

      if (!connector) throw new Error('Connector not found');

      await connectAsync({
        connector,
      });
    } catch (error) {
      console.log('error: ', error);

      dispatch(
        setAlertState({
          type: 'failed',
          text: (error as unknown as string).toString(),
          onClose: () => dispatch(dropAlertState()),
          onSubmit: () => dispatch(dropAlertState()),
        }),
      );
    }
  }, [dispatch, connectAsync, connectors]);

  const disconnect = useCallback(() => {
    localStorage.removeItem(WEB3_AUTH_METHOD_CACHE_KEY);
    deactivate();
  }, [deactivate]);

  return { connect, disconnect };
};

export { useMetamaskAuth };
